export const StatusOptions = [
    { value: "all", label: "ALL" },
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
  ];

  export const TypeOptions = [
    { value: "all", label: "ALL" },
    { value: "medicalCondition", label: "Medical Condition" },
    { value: "medicalStudy", label: "Medical Study" },
    { value: "medicalSurgery", label: "Surgery/ Procedure" },
  ];

  export const DeleteOptions = [
    { value: "notSpecified", label: "Not Specified" },
    { value: "wrongMedicationCondition", label: "Wrong Medical Condition" },
    { value: "duplicateCondition", label: "Duplicate Condition" },
    {
      value: "noLongerExistingCondition",
      label: "Medical Condition No Longer Exists",
    },
    { value: "other", label: "Other" },
  ];